import RecruitmentComponent from './recruitment-component'

export default RecruitmentComponent
